import React from "react";
import styled from "styled-components";
import { Button, Conatainer, Section } from "../../GlobalStyles";
import CompanyIcon from "../images/Icon_Cropped.png";

const Hero = styled(Section)`
  min-height: calc(100vh - 160px);
  display: flex;
  align-items: center;
  background: radial-gradient(circle at 15% 15%, #e9f0ff 0%, #f5f7fb 45%, #f5f7fb 100%);
`;

const HeroContent = styled(Conatainer)`
  display: grid;
  grid-template-columns: 1.25fr 0.9fr;
  gap: 28px;
  align-items: center;

  @media screen and (max-width: 920px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const HeroCopy = styled.div`
  max-width: 700px;

  @media screen and (max-width: 920px) {
    margin: 0 auto;
  }
`;

const HeroIcon = styled.img`
  width: 86px;
  height: 86px;
  object-fit: contain;
  margin-bottom: 16px;
`;

const SubTitle = styled.p`
  color: var(--muted);
  margin: 14px 0 24px;
  max-width: 560px;
  font-size: 1.05rem;
  line-height: 1.72;
`;

const Eyebrow = styled.p`
  color: var(--primary);
  font-size: 0.82rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-weight: 700;
`;

const HeroAside = styled.aside`
  background: #ffffff;
  border: 1px solid #e4e7ec;
  border-radius: 14px;
  box-shadow: var(--shadow);
  padding: 24px;

  h2 {
    font-size: 1.1rem;
    margin-bottom: 12px;
  }

  @media screen and (max-width: 920px) {
    text-align: left;
  }
`;

const PointList = styled.ul`
  list-style: none;
  display: grid;
  gap: 10px;

  li {
    color: var(--muted);
    font-size: 0.96rem;
    position: relative;
    padding-left: 18px;
  }

  li::before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: var(--primary);
    position: absolute;
    left: 0;
    top: 0.56em;
  }
`;

const Home = () => {
  return (
    <Hero>
      <HeroContent>
        <HeroCopy>
          <HeroIcon src={CompanyIcon} alt="Peragal Tech icon" />
          <Eyebrow>Software consultancy</Eyebrow>
          <h1>Simple software solutions that help your business move faster.</h1>
          <SubTitle>
            We design and build reliable web products with clear communication, practical delivery timelines,
            and a focus on outcomes your team can measure.
          </SubTitle>
          <Button as="a" href="mailto:peragaltech@peragaltech.com?subject=Project%20Inquiry" primary>
            Contact Peragal Tech
          </Button>
        </HeroCopy>

        <HeroAside>
          <h2>What you can expect</h2>
          <PointList>
            <li>Clear scope and timelines before delivery starts</li>
            <li>Modern, maintainable engineering standards</li>
            <li>Consistent updates from kickoff to launch</li>
          </PointList>
        </HeroAside>
      </HeroContent>
    </Hero>
  );
};

export default Home;
